import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { NotificacaoSumarioDTO } from "types/dto/NotificacaoSumarioDTO";
import { RequestSumarioNotificacao } from "types/request/RequestSumarioNotificacao";

export const useGetSumarioNotificacao = (request: RequestSumarioNotificacao) => {

  return useFetch<NotificacaoSumarioDTO>({
    key: ["notificacao-sumario", request.uuidUsuario, request.uuidEmpresa],
    url: api.sirens.getSumarioNotificacao,
    params: request,
    enabled: !!request.uuidUsuario && !!request.uuidEmpresa,
  });
};
